// src/views/Settings/account/BillingSection.jsx
//
// Todo el dinero de la cuenta en un sitio. Antes eran tres entradas de menú
// —Wallet, Coins, Subscriptions— más Pricing, cuatro palabras para lo mismo en
// una lista de siete. Ahora son pestañas de una sección, y la pestaña vive en
// la URL para que recargar no vuelva a la primera.
import React from 'react';
import WalletView from '../../Profile/WalletView';

export default function BillingSection({ tab, onTabChange, onViewPlans }) {
  return <WalletView tab={tab} onTabChange={onTabChange} onViewPlans={onViewPlans} />;
}
